import { isString, size, isFinite } from 'underscore';

/**
 * Regex Pattern for wide characters
 */
const wideCharPattern = new RegExp(
  '[\\u1100-\\u11FF]' + // IsHangulJamo
  '|[\\u2E80-\\u2EFF]' + // IsCJKRadicalsSupplement
  '|[\\u3000-\\u303F]' + // IsCJKSymbolsandPunctuation
  '|[\\u3040-\\u309F]' + // IsHiragana
  '|[\\u30A0-\\u30FF]' + // IsKatakana
  '|[\\u3130-\\u318F]' + // IsHangulCompatibilityJamo
  '|[\\u3200-\\u32FF]' + // IsEnclosedCJKLettersandMonths
  '|[\\u3300-\\u33FF]' + // IsCJKCompatibility
  '|[\\u3400-\\u4DBF]' + // IsCJKUnifiedIdeographsExtensionA
  '|[\\u4E00-\\u9FFF]' + // IsCJKUnifiedIdeographs
  '|[\\uAC00-\\uD7AF]' + // IsHangulSyllables
  '|[\\uF900-\\uFAFF]' + // IsCJKCompatibilityIdeographs
  '|[\\uFE30-\\uFE4F]' + // IsCJKCompatibilityForms
  '|[\\uFF01-\\uFF60]' + // Fullwidth Forms Part 1
  '|[\\uFFE0-\\uFFE6]' + // Fullwidth Forms Part 2
  '|[\\uD800-\\uDBFF][\\uDC00-\\uDFFF]' // Astral Planes
  , 'g'
);

/**
 * Get string length, which counting CJK character or Emojis as 2
 * @param {string} str - string to count
 * @returns {int} - length of string
 */
const displayLength = str =>
  (isString(str) ? str.replace(wideCharPattern, '12').length : 0);

export const getLength = (str, distinguishWideChar = false) =>
  (distinguishWideChar ? displayLength(str) : size(str));

const intRemaining = (str, schema) => {
  if (!isFinite(schema.maxLength)) {
    return Number.POSITIVE_INFINITY;
  }

  return schema.maxLength - getLength(str, schema.distinguishWideChar);
};

export const strRemaining = (i18n, str, schema, newI18n) => {
  const remaining = intRemaining(str, schema);

  if (!isFinite(remaining)) {
    return '';
  }
  if (newI18n) {
    return remaining >= 0 ?
      newI18n.getString(_TL_('{{count}} characters remaining'), { count: remaining }) :
      newI18n.getString(_TL_('Exceeded by {{count}} characters'), { count: 0 - remaining });
  }
  return remaining >= 0 ?
    i18n.getString('RemainingCharactersText_New', { count: remaining }) :
    i18n.getString('ExceededCharactersText_New', { count: 0 - remaining });
};

